import React from 'react';
import { css } from '@emotion/css';
import { Msg } from '@/i18n';

const styles = {
  statusInfo: {
    border: '1px solid #d6d6d6',
    borderLeft: '8px solid #237fff',
    backgroundColor: 'transparent',
    display: 'block',
    position: 'relative',
    zIndex: 2,
    textAlign: 'left',
    padding: '12px 12px 12px 55px',

    '@media screen and (min-width: 576px)': {
      padding: '24px 12px 24px 65px',
      width: '530px',
    },

    '&:before': {
      display: 'none',
    },

    i: {
      color: '#237fff',
      position: 'absolute',
      left: '30px',
      top: '28px',
      transform: 'translate(-50%, -50%)',
      fontSize: '26px',

      '@media screen and (min-width: 576px)': {
        top: '38px',
        left: '40px',
      },
    },
    p: {
      fontSize: '14px',
    },
    a: {
      fontSize: '14px',
    },
  },
  h1Title: {
    color: '#252726',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    marginBottom: '5px',

    '@media screen and (min-width: 576px)': {
      lineHeight: '24px',
      fontSize: '20px',
    },
  },
  schufaContainer: {
    border: '1px solid #d6d6d6',
    borderRadius: '4px',
    width: '100%',
    padding: '24px 30px',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: '#333333',

    '@media screen and (min-width: 576px)': {
      width: '530px',
    },
  },
  schufaDesc: {
    paddingLeft: '24px',
  },
  schufaText: {
    display: 'flex',
    flexDirection: 'column',

    '@media screen and (min-width: 576px)': {
      display: 'initial',
    },
  },
  schufaExpiredText: {
    color: '#e74b3c',
  },
  code: {
    fontWeight: 'bold',
  },
} as const;

interface Props {
  isActive: boolean;
  formattedDate: string;
  preview1: string;
  preview2: string;
  preview3: string;
  verificationCode?: string;
  isEntitledPlusRent: boolean;
}

export const SolvencyDocument = ({
  isActive,
  formattedDate,
  preview1,
  preview2,
  preview3,
  verificationCode,
  isEntitledPlusRent,
}: Props) => {
  return (
    <>
      {!isActive && (
        <div className={'padding-bottom-l'}>
          <div className={`${css(styles.statusInfo)}`}>
            <i className='is24-icon-info' />
            <h1 className={`${css(styles.h1Title)}`} data-testid={'schufa-info'}>
              <Msg
                id='benefits.schufaCheckMieterPlus.modal.overview.notActive'
                defaultMessage='Original SCHUFA-BonitätsCheck that...'
              />
            </h1>
            <p>
              <Msg
                id='benefits.schufaCheckMieterPlus.modal.overview.paragraph2'
                defaultMessage='Original SCHUFA-BonitätsCheck that...'
                values={{ formattedDate: formattedDate }}
              />
            </p>
            <a href='/meinkonto/profil/erstellen-myscout/unterlagen/schufa'>
              {isEntitledPlusRent ? (
                <Msg
                  id='benefits.schufaCheckMieterPlus.modal.overview.activateFree'
                  defaultMessage='Original activate free...'
                />
              ) : (
                <Msg
                  id='benefits.schufaCheckMieterPlus.modal.overview.activateNow'
                  defaultMessage='Original activate...'
                />
              )}
            </a>
          </div>
        </div>
      )}
      <a
        className={`${css(styles.schufaContainer)}`}
        href={
          '/meinkonto/profil/erstellen-myscout/unterlagen/schufa?cmp_id=10-051402&cmp_name=residential_profile&cmp_position=residential_benefits&cmp_creative=solvency_cta'
        }
      >
        <img
          src={preview1}
          srcSet={`${preview1} 210w, ${preview2} 420w, ${preview3} 630w`}
          sizes='(min-width: 576px) 200px, 105px'
          alt='boxes'
          width='200px'
        />
        <div className={`${css(styles.schufaDesc)}`}>
          <p className={`${css(styles.schufaText)}`}>
            <Msg
              id='benefits.schufaCheckMieterPlus.modal.overview.verificationCode'
              defaultMessage='Original SCHUFA-BonitätsCheck that...'
            />
            <span className={`${css(styles.code)}`} data-testid={'verification-code'}>
              {verificationCode}
            </span>
          </p>
          <p className={`${!isActive ? css(styles.schufaExpiredText) : ''}`} data-testid={'active-until-date'}>
            <Msg
              id='benefits.schufaCheckMieterPlus.modal.overview.activeUntilDate'
              defaultMessage='Original SCHUFA-BonitätsCheck that...'
              values={{ formattedDate: formattedDate }}
            />
          </p>
        </div>
      </a>
    </>
  );
};
